import React, { Fragment } from 'react'
import PaginatedConnectionTable from 'components/PaginatedConnectionTable'
import graphqlQuery from 'graphs/queries/ProductServers.graphql'
import withConnectionQuery from 'components/withConnectionQuery'
import fields from 'fields/servers'

const RouteCompanyUsers = ({ company, history, ...props }) => (
  <Fragment>
    <PaginatedConnectionTable
      {...props}
      history={history}
      fields={fields}
      onRowClick={(e, row) => history.push(`/admin/servers/${row.id}`)}
      showNew
    />
  </Fragment>
)

export default withConnectionQuery({
  graphqlQuery,
  paginated: true,
  namespace: 'product.servers'
})(RouteCompanyUsers)



// WEBPACK FOOTER //
// ./src/routes/admin/products/servers/index.js